import React, { useCallback, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

import ai from "../../helpers/axios";
import { LoadingButton } from "../shared/loading-button";
import getApiErrorMessage from "../../helpers/get-api-error-message";

const PaymentUnlinkLedgerModal = ({ isOpen, row, onRequestClose }) => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
  const [isSaving, setIsSaving] = useState(false);

  const getToken = useCallback(async () => {
    return getAccessTokenSilently().catch(() => loginWithRedirect());
  }, [getAccessTokenSilently, loginWithRedirect]);

  const handleSubmit = useCallback(async () => {
    setIsSaving(true);

    const token = await getToken();

    const provider = row?.chargeId ? "stripe" : "xero";

    const response = await ai.auth(token)
      .post(`/api/${provider}/transactions/${row._id}/unlink-ledger`)
      .catch((error) => {
        Sentry.captureException(error);
        toast.error(getApiErrorMessage(error, "Error unlinking transaction."));
      });

    if (response?.data) {
      toast.success("Transaction unlinked from Funds Ledger.");
      await onRequestClose();
    }

    setIsSaving(false);
  }, [row, getToken, onRequestClose]);

  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={() => onRequestClose(false)}
      style={{
        overlay: { zIndex: 999999, backgroundColor: "rgb(32 53 68 / 50%)" },
        content: {
          width: "auto",
          padding: "40px",
          border: "none",
          maxWidth: "700px",
          maxHeight: "50%",
          borderRadius: "0",
          boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
        },
      }}
      appElement={document.getElementById("app")}
    >
      <div className="modal-header base-modal">
        <h4>Unlink Payment from the Ledger</h4>
      </div>

      <div className="modal-body base-modal modal-body-with-scroll">
        <div className="w-100 mt-20">
          You are about to unlink the payment from the Funds Ledger. The related Funds Ledger record will also be
          permanently deleted. This action cannot be undone. Are you sure you want to continue?
        </div>
      </div>

      <div className="modal-footer w-100 mt-10 d-flex gap-10">
        <div className="w-100 mt-20 d-flex gap-20">
          <button
            className="base-button evo-blue flex-half"
            type="button"
            onClick={() => onRequestClose(false)}
            disabled={isSaving}
          >
            Cancel
          </button>

          <LoadingButton
            className="base-button btn-danger flex-half"
            type="button"
            onClick={handleSubmit}
            isLoading={isSaving}
          >
            Unlink
          </LoadingButton>
        </div>
      </div>
    </ReactModal>
  );
};

export default PaymentUnlinkLedgerModal;
